var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgBronkhorst = function SvgBronkhorst(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.513,
    height: 238.513,
    overflow: "scroll",
    viewBox: "0 0 238.513 238.513"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e2001a",
    d: "M234.55 109.606l-70.8-70.7c-5.4-5.4-14.1-5.4-19.5 0l-10.8 10.8 59.9 59.9c5.4 5.4 5.4 14.1 0 19.5l-59.9 59.9 10.8 10.8c5.4 5.4 14.1 5.4 19.5 0l70.7-70.7c5.4-5.3 5.4-14.1.1-19.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003064",
    d: "M164.95 109.506l-70.7-70.8c-5.4-5.4-14.1-5.4-19.5 0l-70.7 70.7c-5.4 5.4-5.4 14.1 0 19.5l70.7 70.7c5.4 5.4 14.1 5.4 19.5 0l70.7-70.7c5.4-5.3 5.4-14 0-19.4zm-38.8 14.8l-36.7 36.7c-2.8 2.8-7.3 2.8-10.1 0l-36.7-36.7c-2.8-2.8-2.8-7.3 0-10.1l36.7-36.7c2.8-2.8 7.3-2.8 10.1 0l36.7 36.7c2.8 2.8 2.8 7.3 0 10.1z"
  })));
};

;
export default SvgBronkhorst;